import { TablePerPage, PER_PAGE_OPTIONS } from "../../_CORE/APP/Templates/_UI/Table/_index";
import { ViewPagination } from "./ViewPagination";
import "./_Styles/ViewPagedSection.css";

/*
    Contenedor de paginado para listados que no usan DataTable.

    Mantiene exactamente el mismo criterio visual del resto de la app:
    total a la izquierda, selector Ver 6 / 12 / 25 / infinito a la derecha
    y navegacion de paginas al pie.
*/
export const ViewPagedSection = ({
    pager,
    singular = "registro",
    plural = "registros",
    children,
    className = "",
}) => {
    if (!pager) return children;

    const total = Number(pager.total || 0);
    const options = PER_PAGE_OPTIONS.map((option) => ({
        ...option,
        isDisabled: Number(option.value) !== -1 && total < Number(option.value),
    }));

    return (
        <div className={`LStudio__app_paged_section ${className}`.trim()}>
            {total > 0 && (
                <div className="LStudio__app_paged_section__meta">
                    <span className="LStudio__app_paged_section__total">
                        {total} {total === 1 ? singular : plural}
                    </span>

                    <TablePerPage
                        value={pager.usePerPage}
                        onChange={pager.onChangePerPage}
                        options={options}
                        totalItems={total}
                        label="Ver"
                    />
                </div>
            )}

            {children}

            {total > 0 && (
                <ViewPagination
                    page={pager.usePage}
                    totalPages={pager.totalPages}
                    total={total}
                    perPage={pager.usePerPage}
                    onChange={pager.onChangePage}
                />
            )}
        </div>
    );
};
